import { render, staticRenderFns } from "./QualityControlAuditTrail.vue?vue&type=template&id=040ecee0"
import script from "./QualityControlAuditTrail.vue?vue&type=script&lang=js"
export * from "./QualityControlAuditTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports